module.exports = __webpack_public_path__ + "static/thenaturalstep-logo-9a27df6ac53365c21ab7833f2fa2d95b.png";